<script>
import { mapState, mapActions } from "vuex";

import documentMixin from "@/mixins/documentMixin";

export default {
  mixins: [documentMixin],
  data() {
    return {
      ocrDocuments: [],
      backgroundCheckDocuments: []
    };
  },
  props: {
    professional: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("documents", ["documents"])
  },
  methods: {
    ...mapActions("documents", ["listAllDocuments"]),
    getOcrDocuments() {
      return Object.values(this.documents).filter(document => {
        return this.isOcrDocument(document.document_type);
      });
    },
    getBackgroundDocuments() {
      return Object.values(this.documents).filter(document => {
        return this.isBackgroundCheckDocument(document.document_type);
      });
    },

    async listAll() {
      try {
        await this.listAllDocuments(this.professional.account.id);
      } catch (e) {
        this.$toast.error("Não foi possivel listar os documentos!");
      }
    },

    buildOcrLink() {
      return this.buildCombateAFraudeLink(this.ocrDocuments[0].external_id);
    },
    buildBackgroundCheckLink() {
      return this.buildCombateAFraudeLink(
        this.backgroundCheckDocuments[0].external_id
      );
    }
  },
  async mounted() {
    await this.listAll();
    this.ocrDocuments = this.getOcrDocuments();
    this.backgroundCheckDocuments = this.getBackgroundDocuments();
  }
};
</script>

<template>
  <v-row>
    <v-col cols="12" sm="6" class="py-2">
      <v-btn
        v-if="ocrDocuments.length"
        color="secondary"
        depressed
        elevation="4"
        raised
        :href="buildOcrLink()"
        target="_blank"
      >
        Consultar documentos no CAF
      </v-btn>
      <v-btn
        v-if="backgroundCheckDocuments.length"
        color="secondary"
        depressed
        elevation="4"
        raised
        :href="buildBackgroundCheckLink()"
        target="_blank"
      >
        Consultar antecedentes no CAF
      </v-btn>
    </v-col>
  </v-row>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Register/CombateAFraudeLinks.vue